import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { ChevronRight, User } from "lucide-react";

const AccountPass = () => {
    const navigate = useNavigate();

    return (
        <div className="bg-white dark:bg-[#1E1D21]">
            <div className="sticky top-0 z-50">
                <div className="relative flex items-center justify-center h-12 bg-[#BDE6FF] rounded-b-xl px-2">
                    <IoMdArrowBack
                        onClick={() => navigate("/settings/account")}
                        className="absolute left-2 top-1/2 transition-transform -translate-y-1/2 text-[24px] text-black cursor-pointer"
                    />
                    <p className="text-center font-bold text-[16px] text-black flex-grow">Password</p>
                </div>
            </div>

            <div className="flex flex-col px-3 pt-5">
                <p className="text-[14px] text-black dark:text-white font-bold">Password</p>
                <p className="text-[12px] text-justify text-black dark:text-white pt-1">
                    When you update your password, you'll be signed out of all other browsers and devices for your protection.
                    Choose a strong password to keep your account secure.
                </p>
                <div
                    onClick={() => navigate("/settings/account/edit-pass")}
                    className="flex items-center bg-[#BDE6FF] rounded-lg mt-5 justify-between space-x-3 p-4 border-b border-gray-200 dark:border-gray-800/50 last:border-b-0"
                >
                    <div className="flex items-center space-x-3">
                        <User className="w-4 h-4 text-black dark:text-black" />
                        <span className="text-[14px] text-black dark:text-black">Password</span>
                    </div>
                    <ChevronRight className="w-4 h-4 cursor-pointer text-black dark:text-black" />
                </div>
            </div>
        </div>
    )
}

export default AccountPass